import D2C_ProviderHosting from './Hosting'

class D2C_ProviderUpcloud extends D2C_ProviderHosting {
  static objectType = 'providerType'
  static active = true
  static order = 14
  static providerType = 'Upcloud'
  static providerTitle = 'UpCloud'
  static referal = 'If you don\'t have an Upcloud account you can register with <a href="https://www.upcloud.com/register/?promo=8YR3X6" target="_blank">this link</a> and get free credit: $25.'
  static helpLink = 'https://docs.d2c.io/providers/cloud-providers/#upcloud'
  static fields = {
    ...D2C_ProviderHosting.fields,
    accessId: {
      label: 'API user',
      path: 'auth.accessId',
      required: true,
      default: '',
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
    secretKey: {
      label: 'API password',
      path: 'auth.secretKey',
      required: true,
      default: '',
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
  }
}

export default D2C_ProviderUpcloud
